<template>
  <div class="complete-form-container">
    <InfoContainer
      :infoTitle="completeConfig['infoTitle']"
      :contentConfig="completeConfig['infoContent']"
    >
      <template #basicInfo>
        <CommonDetail
          v-if="isDetail"
          :configArray="detailFormOneConfig"
          :initValue="formData"
        >
          <template #applyOption>
            <el-checkbox-group disabled v-model="itemOptionArray">
              <el-checkbox label="0">1.保证金退还</el-checkbox>
              <el-checkbox label="1">2.办理抵、质押手续</el-checkbox>
              <el-checkbox label="2">3.其它</el-checkbox>
            </el-checkbox-group>
          </template>
        </CommonDetail>
        <avue-form
          ref="basicInfoForm"
          v-else
          v-model="formData"
          :option="projectInfoConfig"
        >
          <template #projectName>
            <!-- 存在绑定ID时不可更改项目 -->
            <CommonSelect
              bindLabel="name"
              bindKey="id"
              bindValue="name"
              dataUrl="bl/blreportstandard/page"
              methods="get"
              dataMethod="params"
              searchKey="name"
              :initParam="initParam"
              :bindId="selectProjectId ? selectProjectId : ''"
              @handleChange="setProjectInfo"
            />
          </template>

          <template #contractName>
            <!-- 存在绑定ID时不可更改项目 -->
            <CommonSelect
              bindLabel="contractName"
              bindKey="id"
              bindValue="contractName"
              dataUrl="bl/blcontractmanage/page"
              methods="get"
              dataMethod="params"
              searchKey="contractName"
              :initParam="contractParam"
              :bindId="selectContractId ? selectContractId : ''"
              @handleChange="setContractInfo"
            />
          </template>
        </avue-form>
      </template>

      <template #paymentInfo>
        <div class="payment_info">
          <div class="watermark" v-if="rentPlanCollections.length>0&&beforeAddDetail.prepayment.isWriteoff==1">提前还款</div>
          <el-table
            :data="rentPlanCollections"
            border
            style="width: 100%"
            show-summary
            :summary-method="getPymentSummaries"
          >
            <el-table-column align="center" label="批次" property="investBatch">
              <template slot-scope="{ row }">
                第{{ row.investBatch }}批
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="paymentBatch"
              label="放款次号"
            >
              <template slot-scope="{ row }">
                第{{ row.paymentBatch }}笔
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="collectionPrincipal"
              label="已还首付款"
              width="120"
            >
              <template slot-scope="{ row }">
                {{ getMoney(Number(row.collectionPrincipal)) }}元
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="surplusPrincipal"
              label="剩余首付款"
              width="120"
            >
              <template slot-scope="{ row }">
                {{ getMoney(Number(row.surplusPrincipal)) }}元
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="collectionInterest"
              label="已还使用费"
              width="120"
            >
              <template slot-scope="{ row }">
                {{ getMoney(Number(row.collectionInterest)) }}元
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="surplusInterest"
              label="剩余使用费"
              width="120"
            >
              <template slot-scope="{ row }">
                {{ getMoney(Number(row.surplusInterest)) }}元
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="issue"
              label="还款期数"
              width="120"
            >
              <template slot-scope="{ row }"> {{ row.issue }}期 </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="collectionIssue"
              label="已还期数"
              width="120"
            >
              <template slot-scope="{ row }">
                {{ row.collectionIssue }}期
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              property="surplusIssue"
              label="剩余期数"
              width="120"
            >
              <template slot-scope="{ row }">
                {{ row.surplusIssue }}期
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>

      <template #gracePeriodInfo>
        <el-table
          :data="overdueInterests"
          border
          style="width: 100%; margin-bottom: 20px"
        >
          <el-table-column align="center" label="批次" property="batch">
            <template slot-scope="{ row }"> 第{{ row.batch }}批 </template>
          </el-table-column>
          <el-table-column align="center" property="" label="超期期数">
            <template slot-scope="{ row }">
              <div>第{{ row.pen }}期</div>
              <div class="blue-word">(第{{ row.phase }}笔)</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="gracePeriodDays"
            label="宽限期天数"
            width="150"
          >
            <template slot-scope="{ row }">
              {{ row.gracePeriodDays }}天
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="overdueDays"
            label="逾期天数"
            width="150"
          >
            <template slot-scope="{ row }"> {{ row.overdueDays }}天 </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="gracePeriodRate"
            label="宽限期费率"
            width="150"
          >
            <template slot-scope="{ row }">
              {{ (Number(row.gracePeriodRate) * 100).toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="overdueInterestRate"
            label="逾期利率"
            width="150"
          >
            <template slot-scope="{ row }">
              {{ (Number(row.overdueInterestRate) * 100).toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="receivableRent"
            label="本期应收账款"
            width="150"
          >
            <template slot-scope="{ row }">
              {{ getMoney(Number(row.receivableRent)) }}元
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="overdueAmount"
            label="超期费用"
            width="150"
          >
            <template slot-scope="{ row }">
              {{ getMoney(Number(row.overdueAmount)) }}元
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="paymentStr"
            label="罚息状态"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            property="rentDate"
            label="还款日"
            width="150"
          >
          </el-table-column>
        </el-table>
        <CommonDetail
          v-if="isDetail"
          :configArray="detailFormTwoConfig"
          :initValue="formData"
        ></CommonDetail>
        <avue-form
          ref="gracePeriodForm"
          v-else
          v-model="formData"
          :option="completePymentConfig"
        >
        <template #creditAmount>
          <el-input
            v-model="formData['creditAmount']"
            placeholder="请输入减免金额"
            oninput ="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>

        </template>
        </avue-form>
      </template>

      <!-- 保证金信息 -->
      <template #marginInfo>
        <el-table :data="deposits" border style="width: 100%">
          <el-table-column align="center" property="batchStr" label="批次">
          </el-table-column>
          <el-table-column
            align="center"
            property="surplusAmount"
            label="保证金金额"
            width="150"
          >
            <template slot-scope="{ row }">
              {{ getMoney(Number(row.surplusAmount)) }}元
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="outlayWayStr"
            label="收取方式"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            property="receivedAmount"
            label="已收保证金"
            width="150"
          >
            <template slot-scope="{ row }">
              {{ getMoney(Number(row.receivedAmount)) }}元
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="expirationTreatmentStr"
            label="到期处理方式"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            property="deductionAmount"
            label="抵扣金额"
            width="150"
          >
            <template slot-scope="{ row, $index }">
              <el-input
                v-if="row.expirationTreatment == 1"
                v-model="row.deductionAmount"
                @change="setDeposits(row, $index, row.deductionAmount)"
              >
                <template #append>元</template>
              </el-input>
              <div class="no-amount" v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="depositsMoney"
            label="剩余保证金"
            width="150"
          >
            <template slot-scope="{ row }">
              <div>
                {{
                  row.depositsMoney && row.depositsMoney != ""
                    ? `${getMoney(Number(row.depositsMoney))}元`
                    : "-"
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <template #completeInfo>
        <!-- 结清合计 -->
        <div class="complete-info" v-if="isDetail">
          <CommonDetail
            v-if="isDetail"
            :configArray="detailFormThreeConfig"
            :initValue="formData"
          ></CommonDetail>
        </div>

        <avue-form
          v-else
          ref="completeInfoForm"
          v-model="formData"
          :option="completeTotalConfig"
        >
        <template #otherAmount>
          <el-input
            v-model="formData['otherAmount']"
            placeholder="请输入其他费用"
            oninput ="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>

        </template>
        </avue-form>
      </template>
    </InfoContainer>
  </div>
</template>
<script>
import {
  addContractCompleteConfig,
  completePymentConfig,
  marginInfoConfig,
  completeTotalConfig,
  detailFormOneConfig,
  detailFormTwoConfig,
  detailFormThreeConfig,
} from "../completeConfig";
import Accessory from "@/components/accessoriesother/accessory";
import CommonSelect from "@/components/commonSelect/commonSelect";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import CommonDetail from "@/components/commonDetail/commonDetail";
import InfoContainer from "@/components/infoContainer/infoContainer";
import {
  beforeCompleteAddDetail,
  completeDetail,
  contractList,
} from "@/api/factoring/factoring";
import { mapGetters } from "vuex";
export default {
  name: "CompleteFormComponent",
  data() {
    return {
      itemOptionArray: [],
      initParam: { auditStatus: 2 },
      contractParam: {},
      selectProjectId: "",
      selectContractId: "",
      tableData: [],
      formData: {},
      beforeAddDetail: {},
      rentPlanCollections: [],
      overdueInterests: [],
      deposits: [],
      marginInfoConfig: marginInfoConfig(),
      completePymentConfig: completePymentConfig(this.changeReduce),
      projectInfoConfig: addContractCompleteConfig(),
      completeTotalConfig: completeTotalConfig(),
      detailFormOneConfig: detailFormOneConfig(),
      detailFormTwoConfig: detailFormTwoConfig(),
      detailFormThreeConfig: detailFormThreeConfig(),
      completeConfig: {
        infoTitle: "合同结清",
        infoContent: [
          {
            title: "项目信息",
            prop: "basicInfo",
          },
          {
            title: "保理首付款及使用费信息",
            prop: "paymentInfo",
          },
          {
            title: "宽限期使用费及罚息信息",
            prop: "gracePeriodInfo",
          },
          {
            title: "保证金信息",
            prop: "marginInfo",
          },
          {
            title: "结清合计",
            prop: "completeInfo",
          },
        ],
      },
    };
  },
  props: {
    isDetail: {
      type: Boolean,
      default: false,
    },
    // 传入数据
    initData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    "formData.creditAmount": {
      handler(newData, oldData) {
        if (newData) {
          this.formData.surplusOverdueAmount = this.formData
            .totalSurplusOverdueAmount
            ? Number(this.formData.totalSurplusOverdueAmount) - Number(newData)
            : "";
          this.formData.surplusOverdueAmountStr = this.formData
            .totalSurplusOverdueAmount
            ? this.getMoney(Number(this.formData.surplusOverdueAmount))
            : "";
        }
      },
      deep: true,
    },
    initData: {
      handler(newData, oldData) {
        if (newData.id) {
          this.formData = newData;
          this.selectProjectId = newData.projectInfoId;
          this.selectContractId = newData.conManageId;
          // 申请事项
          if (this.formData.applyItems != "") {
            this.itemOptionArray = newData.applyItems.split(",");
            this.formData.applyOption = newData.applyItems.split(",");
          }
          // 减免金额
          this.formData.creditAmount = newData.reduceAmount;
          this.formData.creditAmountStr =
            newData.creditAmount && newData.creditAmount != -1
              ? this.getMoney(Number(newData.creditAmount))
              : "";
          // 保证金
          this.formData.deposits = newData.deductions;
          this.queryCompleteDetail(this.$route.params.id);
        }
      },
      immediate: true,
    },
  },
  components: {
    Accessory,
    CommonSelect,
    CommentBlock,
    CommonDetail,
    InfoContainer,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      // this.queryCompleteDetail(this.id)
    }
  },
  methods: {
    async queryContractDetail(id) {
      let res = await contractList({ id });
      let data = res.data.data.records;
      this.setContractInfo(data[0]);
    },

    async queryCompleteDetail(id) {
      let res = await completeDetail({ id });
      if (res.data.code == 200) {
        console.info(res.data.data, "completeDetail");
        let resData = res.data.data;
        // 处理数据
        this.formData.selectProjectId = resData.projectInfoId;
        this.selectProjectId = resData.projectInfoId;

        this.formData.selectContractId = resData.conManageId;
        this.selectContractId = resData.conManageId;
        if (this.isDetail) {
          this.queryContractDetail(this.selectContractId);
        }
        this.$forceUpdate();
      }
    },

    setDeposits(row, index, value) {
      if (Number(row.receivedAmount) < Number(row.deductionAmount)) {
        this.deposits[index].deductionAmount = 0;
        this.$set(
          this.deposits[index],
          "depositsMoney",
          Number(row.receivedAmount)
        );
        this.$message.warning("输入的抵扣金额不得大于已收保证金金额");
      } else {
        // let newObj = this.deposits[index]
        // newObj.depositsMoney = Number(row.receivedAmount) - Number(row.deductionAmount)
        // this.deposits[index] = newObj
        // this.deposits[index].depositsMoney = Number(row.receivedAmount) - Number(row.deductionAmount)
        let initData = Number(row.receivedAmount) - Number(row.deductionAmount);
        this.$set(this.deposits[index], "depositsMoney", initData);
      }
      this.$forceUpdate();
    },

    getPymentSummaries(param) {
      const sumProperty = [
        "collectionPrincipal",
        "surplusPrincipal",
        "collectionInterest",
        "surplusInterest",
      ];
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (sumProperty.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(Number(value)))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = `${this.getMoney(sums[index])}元`;
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
          return;
        }
      });

      return sums;
    },

    setProjectInfo(data) {
      if (data && JSON.stringify(data) != "{}") {
          this.$emit("setBasicInfoData",data)
        // 项目名称
        this.formData.projectName = data.name;
        // 尽调ID
        this.formData.reportId = data.id;

        this.contractParam = {
          reportId: data.id,
          isInvest: 1,
          listScene: "jq",
          auditStatus: 2,
        };
      } else {
        this.clearData();
      }
    },

    setContractInfo(data) {
      if (data && JSON.stringify(data) != "{}") {
        // 合同金额
        this.formData.contractId = data.id;
        // 合同名称
        this.formData.contractName = data.contractName;
        // 合同金额
        this.formData.contractFactoringCredit = data.factoringCredit
          ? `${this.getMoney(Number(data.factoringCredit))}`
          : "";
        // 协办
        this.formData.assistUserName = data.assistUserName;
        // 主办
        this.formData.managerUserName = data.managerUserName;
        // 所属部门
        this.formData.managerDeptName = data.managerDeptName;
        // 保理商
        this.formData.formAccountingEntityStr = data.formAccountingEntityStr;
        // 客户名称
        this.formData.sellerCustName = data.sellerCustName;
        // 查询结清前详情
        this.queryBeforeCompleteInfo(data.id);
        this.$forceUpdate();
      } else {
        this.clearData();
      }
    },

    clearData() {
      this.deposits = [];
      this.rentPlanCollections = [];
      this.overdueInterests = [];
      // 项目名称
      this.formData.projectName = this.formData.name;
      // 尽调ID
      this.formData.reportId = this.formData.id;
      this.formData.contractId = "";
      // 合同名称
      this.formData.contractName = "";
      // 合同金额
      this.formData.contractFactoringCredit = "";
      // 协办
      this.formData.assistUserName = "";
      // 主办
      this.formData.managerUserName = "";
      // 所属部门
      this.formData.managerDeptName = "";
      // 保理商
      this.formData.formAccountingEntityStr = "";
      // 客户名称
      this.formData.sellerCustName = "";
      // 总宽限期使用费
      this.formData.totalExpireAmount = "";
      this.formData.totalExpireAmountStr = "";
      // 总罚息金额
      this.formData.totalOverdueInterestAmount = "";
      this.formData.totalOverdueInterestAmountStr = "";
      // 总超期金额
      this.formData.totalOverdueAmount = "";
      this.formData.totalOverdueAmountStr = "";
      // 剩余总超期金额
      this.formData.totalSurplusOverdueAmount = "";
      this.formData.totalSurplusOverdueAmountStr = "";

      // 剩余保理首付款
      this.formData.totalSurplusPrincipal = "";
      this.formData.totalSurplusPrincipalStr = "";

      // 剩余使用费
      this.formData.totalSurplusInterest = "";
      this.formData.totalSurplusInterestStr = "";

      // 剩余超期费用 (剩余总超期金额-减免金额)
      this.formData.surplusOverdueAmount = "";
      this.formData.surplusOverdueAmountStr = "";

      // 剩余退还保证金
      this.formData.totalSurplusRefundAmount = "";
      this.formData.totalSurplusRefundAmountStr = "";
    },

    async queryBeforeCompleteInfo(id) {
      let self = this;
      let res = await beforeCompleteAddDetail({ id });
      if (res.data.code == 200) {
        this.beforeAddDetail = res.data.data;
        this.rentPlanCollections = res.data.data.rentPlanCollections;
        this.overdueInterests = res.data.data.overdueInterests;
        let deposits = res.data.data.deposits;
        if (this.formData.deductions && this.formData.deductions.length > 0) {
          deposits.map((item) => {
            let depositsOne = self.formData.deductions.filter((i) => {
              return i.depositId == item.id;
            });
            if (depositsOne.length > 0)
              item.deductionAmount = depositsOne[0].deductionAmount;
          });
        }
        this.deposits = deposits;
        // 处理数据
        this.dealData(res.data.data);
      }
    },

    dealData(data) {
      let setData = {
        ...this.formData,
      };
      // 总宽限期使用费
      setData.totalExpireAmount = data.totalExpireAmount;
      setData.totalExpireAmountStr =
        data.totalExpireAmount && data.totalExpireAmount != "-1"
          ? this.getMoney(Number(data.totalExpireAmount))
          : "";
      // 总罚息金额
      setData.totalOverdueInterestAmount = data.totalOverdueInterestAmount;
      setData.totalOverdueInterestAmountStr =
        data.totalOverdueInterestAmount && data.totalOverdueInterestAmount != ""
          ? this.getMoney(Number(data.totalOverdueInterestAmount))
          : "";
      // 总超期金额
      setData.totalOverdueAmount = data.totalOverdueAmount;
      setData.totalOverdueAmountStr =
        data.totalOverdueAmount && data.totalOverdueAmount != "-1"
          ? this.getMoney(Number(data.totalOverdueAmount))
          : "";
      // 剩余总超期金额
      setData.totalSurplusOverdueAmount = data.totalSurplusOverdueAmount;
      setData.totalSurplusOverdueAmountStr =
        data.totalSurplusOverdueAmount && data.totalSurplusOverdueAmount != "-1"
          ? this.getMoney(Number(data.totalSurplusOverdueAmount))
          : "";
      // 减免金额
      // this.formData.creditAmount = data.creditAmount?data.creditAmount:''
      // this.formData.creditAmountStr = data.creditAmount&& data.creditAmount != -1?this.getMoney(Number(data.creditAmount)):''

      // 剩余保理首付款
      setData.totalSurplusPrincipal = data.totalSurplusPrincipal;
      setData.totalSurplusPrincipalStr =
        data.totalSurplusPrincipal && data.totalSurplusPrincipal != -1
          ? this.getMoney(Number(data.totalSurplusPrincipal))
          : "";

      // 剩余使用费
      setData.totalSurplusInterest = data.totalSurplusInterest;
      setData.totalSurplusInterestStr = this.getMoney(
        Number(data.totalSurplusInterest)
      );

      // 剩余超期费用 (剩余总超期金额-减免金额)
      setData.surplusOverdueAmount =
        Number(data.totalSurplusOverdueAmount) -
        (this.formData.creditAmount && this.formData.creditAmount != ""
          ? Number(this.formData.creditAmount)
          : 0);
      setData.surplusOverdueAmountStr =
        this.formData.surplusOverdueAmount &&
        this.formData.surplusOverdueAmount != ""
          ? this.getMoney(Number(this.formData.surplusOverdueAmount))
          : "";

      // 剩余退还保证金
      setData.totalSurplusRefundAmount = data.totalSurplusRefundAmount;
      setData.totalSurplusRefundAmountStr = this.getMoney(
        Number(data.totalSurplusRefundAmount)
      );

      this.formData = setData;
    },

    changeReduce(value, column) {
      this.formData.surplusOverdueAmount =
        Number(this.formData.totalSurplusOverdueAmount) - Number(value);
      this.formData.surplusOverdueAmountStr = this.getMoney(
        Number(this.formData.surplusOverdueAmount)
      );
    },

    validForm(formValid = true) {
      let self = this;
      return new Promise((resolve, reject) => {
        let submitForm = {
          itemOptionArray: this.itemOptionArray,
          result: true,
          formData: self.formData,
          beforeAddDetail: self.beforeAddDetail,
          rentPlanCollections: self.rentPlanCollections,
          overdueInterests: self.overdueInterests,
          deposits: self.deposits,
        };
        if (formValid) {
          self.$refs.basicInfoForm.validate((valid, done) => {
            done();
            if (valid) {
              self.$refs.gracePeriodForm.validate((valids, dones) => {
                dones();
                if (valids) {
                  resolve(submitForm);
                } else {
                  resolve({ result: false });
                  this.$message.warning("请补全宽限期使用费及罚息信息");
                }
              });
            } else {
              resolve({ result: false });
              this.$message.warning("请补全项目信息");
            }
          });
        } else {
          resolve(submitForm);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.complete-form-container {
  .blue-word {
    color: #66b1ff;
  }
  .complete-info {
    background-color: #f7f9fe;
    border-radius: 3px;
    border: 1px solid #e4e4e4;
    padding: 10px 0;
  }
}
.payment_info {
  position: relative;
  .watermark {
    position: absolute;
    width:100%;
    font-size: 40px;
    color: #FF0000;
    letter-spacing: 100px;
    text-shadow: 2px 3px 1px rgba(255, 0 ,0 ,0.5);
    opacity: 0.8;
    z-index: 20;
    left: 50%;
    top: 20%;
    text-align: center;
    transform: rotate(-5deg) translate(-50%,-50%);
  }
}
</style>